<template>
	<div :class="['online-shopping-page', { mobile: isMobile }]">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_online_shopping_page_v2.sec_01.title.one')
					}}<br />
					{{ $t('new_ui.personal_online_shopping_page_v2.sec_01.title.two') }}
					<strong>
						{{
							$t('new_ui.personal_online_shopping_page_v2.sec_01.title.three')
						}}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.personal_online_shopping_page_v2.sec_01.desc.one')
					}}<br />
					{{ $t('new_ui.personal_online_shopping_page_v2.sec_01.desc.two') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_online_shopping_page_v2.sec_01.btn.one') }}
					</a>
					<a
						href="javascript:void(0)"
						@click="showComingSoon"
						class="btn-type-02"
					>
						{{ $t('new_ui.personal_online_shopping_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-02">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_online_shopping_page_v2.sec_02.title.one') }}
					<br />
					{{ $t('new_ui.personal_online_shopping_page_v2.sec_02.title.two') }}
				</h3>
				<div class="step-box">
					<ul>
						<li>
							<img :src="img.imgOnlineStep01" alt="" />
							<p>
								{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.one.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.one.two',
									)
								}}<strong>{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.one.three',
									)
								}}</strong>
							</p>
						</li>
						<li v-if="isMobile">
							<img :src="img.imgDot" alt="" />
						</li>
						<li>
							<img :src="img.imgOnlineStep02" alt="" />
							<p>
								{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.two.one',
									)
								}}<br />
								<strong>{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.two.two',
									)
								}}</strong>
								{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.two.three',
									)
								}}
							</p>
						</li>
						<li v-if="isMobile">
							<img :src="img.imgDot" alt="" />
						</li>
						<li>
							<img :src="img.imgOnlineStep03" alt="" />
							<p>
								{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.three.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.three.two',
									)
								}}<strong>{{
									$t(
										'new_ui.personal_online_shopping_page_v2.sec_02.step.three.three',
									)
								}}</strong>
							</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{
								$t('new_ui.personal_online_shopping_page_v2.sec_03.title.one')
							}}
						</h3>
						<p>
							{{ $t('new_ui.personal_online_shopping_page_v2.sec_03.desc.one')
							}}<strong>{{
								$t('new_ui.personal_online_shopping_page_v2.sec_03.desc.two')
							}}</strong>
							<br />
							{{
								$t('new_ui.personal_online_shopping_page_v2.sec_03.desc.three')
							}}
							<br />
							{{
								$t('new_ui.personal_online_shopping_page_v2.sec_03.desc.four')
							}}
							<br />
							{{ $t('new_ui.personal_online_shopping_page_v2.sec_03.desc.five')
							}}<strong>
								{{
									$t('new_ui.personal_online_shopping_page_v2.sec_03.desc.six')
								}}
							</strong>
						</p>
					</div>
					<div class="img-box">
						<img :src="img.imgOnlineSec03" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgOnlineSec04" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{
								$t('new_ui.personal_online_shopping_page_v2.sec_04.title.one')
							}}
						</h3>
						<p>
							{{
								$t('new_ui.personal_online_shopping_page_v2.sec_04.desc.one')
							}}
							<br />
							{{
								$t('new_ui.personal_online_shopping_page_v2.sec_04.desc.two')
							}}
							<br />
							{{
								$t('new_ui.personal_online_shopping_page_v2.sec_04.desc.three')
							}}
						</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgOnlineSec03 from '@/assets/images/v2/img-online-sec-03.png';
import imgOnlineSec04 from '@/assets/images/v2/img-online-sec-04.png';
import imgOnlineStep01 from '@/assets/images/v2/img-online-step-01.png';
import imgOnlineStep02 from '@/assets/images/v2/img-online-step-02.png';
import imgOnlineStep03 from '@/assets/images/v2/img-online-step-03.png';
import imgDot from '@/assets/images/v2/img-dot.png';

export default {
	data: () => {
		return {
			mobile: window.innerWidth <= 768,
			img: {
				imgOnlineSec03,
				imgOnlineSec04,
				imgOnlineStep01,
				imgOnlineStep02,
				imgOnlineStep03,
				imgDot,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		showComingSoon() {
			alert('Coming soon.');
		},
	},
};
</script>
